module.exports = __webpack_public_path__ + "img/icon_mine_like.db593075.png";